import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Typewriter from "typewriter-effect";
import { todBill, menuBill, especiallyBill, buttonArrow } from "@/assets";
import AnimatedBox from "../Layouts/AnimatedBox";

const HeroSection = () => {
  const { i18n, t } = useTranslation();
  const [hover, setHover] = useState(false);

  return (
    <section className=" text-center">
      <div className="flex pt-12 xl:pt-0 flex-col xl:flex-row items-center xl:gap-10 relative xl:h-[60vh] bg-linear">
        <div className="md:ps-20 w-full flex-col flex gap-7 mb-8 xl:mb-28 text-start px-4">
          <h1 className="text-textHeading font-semibold xl:w-[50%] text-3xl sm:text-4xl md:text-5xl xl:text-6xl xl:leading-[1.3]">
            {t("home.mainTitle")} {t("home.best")}
            <span className="flex items-center gap-2 text-primary">
              {t("home.manage")}
              <Typewriter
                options={{
                  strings: [t("home.restaurants"), t("home.Cafes")],
                  autoStart: true,
                  loop: true,
                  cursor: "",
                }}
              />
            </span>
          </h1>
          <p className="text-textBody font-medium text-lg xl:max-w-[520px] 2xl:max-w-[600px]">
            {t("links.footerText")}
          </p>
          <div className="flex items-center gap-4">
            <AnimatedBox type="fade-left">
              <Link to="/packages" className="w-fit h-fit">
                <button
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  className={`${
                    i18n.language === "ar" ? "flex-row" : "flex-row-reverse"
                  } bg-primary transition-all rounded-full h-11 w-11 flex items-center justify-center overflow-hidden`}
                >
                  <span
                    className={`${hover ? "animate-slide-icon" : ""}`}
                    key={hover ? "hovered" : "default"}
                  >
                    <img
                      src={buttonArrow}
                      alt="arrow"
                      className="w-3 rotate-180"
                    />
                  </span>
                </button>
              </Link>
            </AnimatedBox>
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, filter: "blur(1px)" }}
          animate={{ opacity: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          className={`${
            i18n.language === "ar" ? "left-0" : "right-0"
          } h-full xl:w-[50%] xl:absolute`}
        >
          <video
            autoPlay
            loop
            muted
            className="w-full h-full object-cover pointer-events-none"
            poster="https://back.skilltax.sa/public/videos/screen.jpeg"
          >
            <source
              src="https://back.skilltax.sa/public/videos/IMG_5075.MP4"
              type="video/mp4"
            />
          </video>
        </motion.div>
      </div>
      <div className="container flex justify-center w-full">
        <div
          id="services"
          className="flex flex-col lg:flex-row w-full max-w-[999px] justify-center relative xl:top-[-75px] items-center gap-2 py-7 lg:py-10 "
        >
          <AnimatedBox duration={0.4} className="flex-1 w-full">
            <Link className="w-full" to="services/menu">
              <div className="bg-white hover:scale-[1.04] duration-200 rounded-[10px] py-7 px-8 flex items-start flex-col justify-between flex-1 gap-6 ">
                <img
                  loading="lazy"
                  src={menuBill}
                  alt="bill-icon"
                  className="w-8"
                />
                <p className="text-2xl font-medium text-textBody">
                  {t("home.menu")}
                </p>
              </div>
            </Link>
          </AnimatedBox>
          <AnimatedBox duration={0.6} delay={0.2} className="flex-1 w-full">
            <Link className="w-full" to="services/tod">
              <div className="bg-white hover:scale-[1.04] duration-200 rounded-[10px] py-7 px-8 flex items-start flex-col justify-between flex-1 gap-6 relative">
                {/* <img
              loading="lazy"
              src={circle}
              alt="icon-circle"
              className="hidden md:block absolute h-20 top-[-40px] z-[-1]"
            /> */}
                <img
                  loading="lazy"
                  src={todBill}
                  alt="bill-icon"
                  className="w-8"
                />
                <p className="text-2xl font-medium text-textBody">
                  {t("home.loyalty")}
                </p>
              </div>
            </Link>
          </AnimatedBox>
          <AnimatedBox duration={0.7} delay={0.3} className="flex-1 w-full">
            <Link className="w-full" to="services/special">
              <div className="bg-white hover:scale-[1.04] duration-200 rounded-[10px] py-7 px-8 flex items-start flex-col justify-between flex-1 gap-6 ">
                <img
                  loading="lazy"
                  src={especiallyBill}
                  alt="bill-icon"
                  className="w-8"
                />
                <p className="text-2xl font-medium text-textBody">
                  {t("home.services")}
                </p>
              </div>
            </Link>
          </AnimatedBox>
          {/* <div className="bg-white rounded-[10px] py-7 px-8 flex items-start flex-col justify-between flex-1 gap-6">
            <img
              loading="lazy"
              src={witterBill}
              alt="bill-icon"
              className="w-8"
            />
            <p className="text-2xl font-medium text-textBody">
              {t("home.witter")}
            </p>
          </div> */}
        </div>
      </div>
      <div className="container">
        {/* <div className="relative my-7 xl:mb-8 xl:mt-11">
          <a href="#services">
            <button className="bg-white hover:scale-90 transition-all text-[#5867C2] rounded-[10px] h-[42px] w-[132px] font-bold text-xs xl:text-sm shadow-[0px_20px_60px_0px_#92A1F9]">
              <span className="-mb-1 sm:mb-0 block">{t("home.explore")}</span>
            </button>
          </a>
          <div className="hidden xl:block absolute left-[330px] top-[-16px]">
            <img loading="lazy" src={homeArrow} alt="arrow" />
          </div>
        </div> 
        <div className="w-full flex justify-center rounded-[20px]">
          <img
            loading="lazy"
            className="w-full max-w-[992px] rounded-[20px] object-cover h-[204px] sm:h-60 md:h-80 lg:h-96 xl:h-[426px]"
            src={skilltaxGroup}
            alt="skilltax-group"
          />
        </div>
        <div className="animate-bounce	 flex justify-center my-7 xl:my-8">
          <img loading="lazy" src={homeArrows} alt="arrow-bottom" />
        </div> */}
        {/* Here */}
        <div className="flex flex-col gap-2 md:gap-3 lg:gap-5 mt-6">
          <p className="text-xl md:text-2xl lg:text-3xl font-medium text-textBody">
            {t("home.enjoy")}
          </p>

          <p className="text-base md:text-lg lg:text-xl font-medium text-textBody">
            {t("home.organization")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
